var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnwserIconUnsafe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 79.55 75.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-width: 0px;\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-3 {\n        fill: #facc10;\n      }\n\n      .cls-4 {\n        fill: #161615;\n      }\n\n      .cls-5 {\n        fill: #d11917;\n      }\n\n      .cls-6 {\n        fill: #691412;\n      }\n\n      .cls-7 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    width: 79.55,
    height: 75.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.94,0c-.24,0-.48.03-.72.07-1.61.36-2.98,1.43-3.71,2.91L.58,63.64c-.77,1.36-.77,3.02,0,4.37.47.74,7.27,7.25,12.82,7.79l61.86-11.98c1.61-.36,2.98-1.43,3.71-2.9.36-.69.56-1.46.57-2.24v-.11c0-.71-.2-1.41-.57-2.02L48.04,7.87c-.35-.56-9.67-6.96-9.67-6.96-.2-.18-.42-.33-.66-.46l-.18-.12v.02c-.49-.22-1.01-.34-1.54-.34h-.06Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    width: 79.55,
    height: 75.8
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6053",
    "data-name": "Groupe 6053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5987",
    "data-name": "Groupe 5987"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5986",
    "data-name": "Groupe 5986"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26712",
    "data-name": "Trac\\xE9 26712",
    className: "cls-5",
    d: "M78.97,56.55L48.04,7.87c-.35-.56-9.67-6.96-9.67-6.96-.2-.18-.42-.33-.66-.46l-.18-.12v.02c-.73-.33-1.54-.43-2.32-.27-1.61.36-2.98,1.43-3.71,2.91L.58,63.64c-.77,1.36-.77,3.02,0,4.37.47.74,7.27,7.25,12.82,7.79l61.86-11.98c1.61-.36,2.98-1.43,3.71-2.9.77-1.36.77-3.02,0-4.37"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5989",
    "data-name": "Groupe 5989"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5988",
    "data-name": "Groupe 5988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26713",
    "data-name": "Trac\\xE9 26713",
    className: "cls-6",
    d: "M49.07,0c-3.4.6-6.62,1.94-9.44,3.92-2.87,2.11-5.23,4.83-6.92,7.97C11.7,48.49,8.86,59.19,7.97,63.69c-1.37,6.87-2.06,10.3-2.1,10.91-.3,4.29.14,6.95-1.68,9.02-1.62,1.84-4.18,2.25-6.08,2.31l-24.61-32.96C-1.44,13.48,21.27-13.49,30.27-13.07c2.34.14,4.65.64,6.85,1.47C43.94-8.83,47.54-2.97,49.07,0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5991",
    "data-name": "Groupe 5991"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5990",
    "data-name": "Groupe 5990"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26715",
    "data-name": "Trac\\xE9 26715",
    className: "cls-3",
    d: "M16.85,69.99c-.63.15-1.29-.11-1.65-.65-.34-.6-.34-1.34,0-1.94L42.68,13.51c.33-.66.93-1.13,1.65-1.29.63-.15,1.29.11,1.65.65l27.48,43.25c.34.6.34,1.34,0,1.94-.33.66-.93,1.13-1.65,1.29l-54.96,10.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26716",
    "data-name": "Trac\\xE9 26716",
    className: "cls-7",
    d: "M18.43,66.09c-.55.13-1.12-.09-1.43-.56-.3-.52-.3-1.16,0-1.68l23.77-46.61c.28-.57.81-.98,1.43-1.12.55-.13,1.12.09,1.43.56l23.77,37.4c.3.52.3,1.16,0,1.68-.28.57-.81.98-1.43,1.12l-47.53,9.2Z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26717",
    "data-name": "Trac\\xE9 26717",
    className: "cls-4",
    d: "M41.64,48.78l-1.62-13.59-.17-6.37,5.22-.8.17,6.37-.87,13.97-2.73.42ZM40.78,55.94l-.14-5.21,4.83-.74.14,5.21-4.83.74Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnwserIconUnsafe);
export default __webpack_public_path__ + "static/media/anwser_icon_unsafe.31b4a1bf94ea9259d1ced2ce9909cf1b.svg";
export { ForwardRef as ReactComponent };